import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ReportStatus } from 'interfaces';

export const REPORT_STATUSES: { [key: string]: ReportStatus } = {
   REPORTED: 'REPORTED',
   REVIEWED: 'REVIEWED',
   CANCELED: 'CANCELED',
};

export const useReportStatuses = () => {
   const { t } = useTranslation();

   const REPORT_STATUSES_AND_LABELS = useMemo(
      () =>
         ({
            REPORTED: { label: t('report_statuses.reported'), variant: 'REPORTED' },
            REVIEWED: { label: t('report_statuses.reviewed'), variant: 'REVIEWED' },
            CANCELED: { label: t('report_statuses.canceled'), variant: 'CANCELED' },
         } as const),
      [t],
   );

   return { REPORT_STATUSES_AND_LABELS };
};
